import React from 'react';
import { useAppSelector } from '../../app/hooks';

function WeaveTrainerHeader() {
  const level = useAppSelector(state => state.weaveTrainer.level);
  const pracs = useAppSelector(state => state.weaveTrainer.pracs);
  const pracs2 = useAppSelector(state => state.weaveTrainer.pracs2);
  const remainderPracs = useAppSelector(state => state.weaveTrainer.remainderPracs);
  const pracsDiff = pracs - pracs2;
  
  return (
    <div className="weave-trainer-footer mt-3">
      <div className="d-flex flex-wrap justify-content-center">
        <div className="me-3">
          Level Required: <span className="fw-bold">{level}</span>,
        </div>
        <div className="me-3">
          Practices: <span className="fw-bold">{pracs}</span>,
        </div>
        <div className="me-3">
          Remainder: <span className="fw-bold">{remainderPracs}</span>,
        </div>
        <div className="me-0">
          Saved: <span className="fw-bold">{-pracsDiff}</span>
        </div>
      </div>
    </div>
  );
}

export default WeaveTrainerHeader;